"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRadioButtonIconStyles = exports.getDisabledIconStyle = exports.inputStyle = void 0;
var react_1 = require("@emotion/react");
var constant_1 = require("../../../constant");
var style_1 = require("../../../style");
var variables_1 = require("../../../style/variables");
var Blue = style_1.SixsenseColor.Blue, Gray = style_1.SixsenseColor.Gray, Red = style_1.SixsenseColor.Red, White = style_1.SixsenseColor.White;
exports.inputStyle = react_1.css({
    position: 'absolute',
    opacity: 0,
    width: 0,
    height: 0,
});
var getDisabledIconStyle = function (checked, themeName) {
    if (checked === void 0) { checked = false; }
    if (themeName === void 0) { themeName = ''; }
    if (themeName !== constant_1.DESIGN_SYSTEM) {
        return react_1.css({
            backgroundColor: Gray.LIGHT_5,
            borderColor: Gray.LIGHT_3,
            color: Gray.LIGHT_2,
            cursor: 'not-allowed',
            '&:hover': {
                borderColor: Gray.LIGHT_3,
            },
        });
    }
    if (checked) {
        return react_1.css({
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            cursor: 'not-allowed',
            ':focus-within': {
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
                borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
                boxShadow: 'none',
            },
            ':hover': {
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
                borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            },
        });
    }
    return react_1.css({
        backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_6 + ")",
        borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        cursor: 'not-allowed',
        ':focus-within': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_6 + ")",
            borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            boxShadow: 'none',
        },
        ':hover': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_6 + ")",
            borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        },
    });
};
exports.getDisabledIconStyle = getDisabledIconStyle;
var getDefaultThemeRadioButtonIconStyle = function (theme) { return ({
    base: {
        container: {
            default: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: White.DEFAULT,
                border: "1px solid " + Gray.LIGHT_2,
                '&:hover': {
                    borderColor: Blue.DEFAULT,
                },
                borderRadius: style_1.pxToRem(10),
                width: style_1.pxToRem(16),
                height: style_1.pxToRem(16),
            },
        },
    },
    checked: {
        container: {
            default: {
                backgroundColor: White.DEFAULT,
                borderColor: Blue.DEFAULT,
                color: theme.color.PRIMARY.DEFAULT,
            },
        },
    },
    error: {
        container: {
            default: {
                backgroundColor: White.DEFAULT,
                borderColor: Red.DEFAULT,
                '&:hover': {
                    borderColor: Red.DEFAULT,
                },
                color: Red.DEFAULT,
            },
        },
    },
}); };
var designSystemRadioButtonIconConfig = {
    base: {
        container: {
            default: {
                alignItems: 'center',
                backgroundColor: "var(" + variables_1.RootColor.White + ")",
                border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'row',
                height: '16px',
                justifyContent: 'center',
                width: '16px',
            },
            focused: {
                borderColor: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
                boxShadow: "var(" + variables_1.Focus.PRIMARY_LIGHT + ")",
            },
            hovered: {
                borderColor: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
            },
        },
    },
    checked: {
        container: {
            default: {
                backgroundColor: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
                borderColor: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
            },
            focused: {
                backgroundColor: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
                borderColor: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
                boxShadow: "var(" + variables_1.Focus.PRIMARY_LIGHT + ")",
            },
            hovered: {
                backgroundColor: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
                borderColor: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
            },
        },
    },
};
var getRadioButtonIconStyles = function (theme) {
    var _a;
    if (theme.name === constant_1.DESIGN_SYSTEM) {
        return {
            root: function (checked) {
                return react_1.css({
                    ':focus-within': {
                        '.icon': __assign({}, (checked
                            ? designSystemRadioButtonIconConfig.checked.container.focused
                            : designSystemRadioButtonIconConfig.base.container.focused)),
                    },
                    ':hover': {
                        '.icon': __assign({}, (checked
                            ? designSystemRadioButtonIconConfig.checked.container.hovered
                            : designSystemRadioButtonIconConfig.base.container.hovered)),
                    },
                });
            },
            container: react_1.css(__assign({}, designSystemRadioButtonIconConfig.base.container.default)),
            checkedContainer: react_1.css(__assign({}, designSystemRadioButtonIconConfig.checked.container.default)),
        };
    }
    var style = getDefaultThemeRadioButtonIconStyle(theme);
    return {
        container: react_1.css(__assign({}, style.base.container.default)),
        checkedContainer: react_1.css(__assign({}, style.checked.container.default)),
        errorContainer: react_1.css(__assign({}, (_a = style.error) === null || _a === void 0 ? void 0 : _a.container.default)),
    };
};
exports.getRadioButtonIconStyles = getRadioButtonIconStyles;
